import ApiService from '../api.services';

const FinancialTypeService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/financialtype');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/financialtype/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        try {
            const data = {
                type: form
            }
            const res = await ApiService.post('/api/financialtype', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, data) {
        try {
            const response = await ApiService.put(`/api/financialtype/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/financialtype/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default FinancialTypeService;

export { FinancialTypeService };

